import { useCallback, useEffect, useRef, useState } from "react";
import { getRoutine, RoutineApiError } from "@/lib/routineApi";
import type { RoutineSnapshot } from "@/lib/routineTypes";
export function useRoutine(id: string, shareToken?: string) {
  const [data, setData] = useState<RoutineSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);
  const request = useRef(0);
  const refresh = useCallback(async () => {
    const sequence = ++request.current;
    try {
      const result = await getRoutine(id, shareToken);
      if (sequence === request.current) {
        setData(result);
        setError(null);
      }
    } catch (e) {
      if (sequence === request.current) {
        if (
          e instanceof RoutineApiError &&
          [401, 403, 404].includes(e.status ?? 0)
        )
          setData(null);
        setError(
          e instanceof Error ? e.message : "Could not load routine video.",
        );
      }
    }
  }, [id, shareToken]);
  useEffect(() => {
    setData(null);
    setError(null);
    void refresh();
    const interval = window.setInterval(() => {
      if (!document.hidden) void refresh();
    }, 10000);
    const onFocus = () => {
      void refresh();
    };
    window.addEventListener("focus", onFocus);
    window.addEventListener("bollyrhythm:routine-updated", onFocus);
    return () => {
      request.current++;
      window.clearInterval(interval);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("bollyrhythm:routine-updated", onFocus);
    };
  }, [refresh]);
  return { data, error, refresh };
}
